// import { init_backlog_state } from "./backlog.reducer";

export const get_intm_backlog_intermediate_status = (state, category) => {
  return state.po_backlog_reducer.backlog?.[category]?.intermediate_states;
};

export const get_po_backlog_state = (state) => {
  return state.po_backlog_reducer;
};

// export const get_intm_backlog_insights = (state) => {
//   return state.po_backlog_reducer.backlog.intm.insights;
// };
// export const get_cb_backlog_insights = (state) => {
//   return state.po_backlog_reducer.backlog.cb.insights;
// };
// export const get_fp_backlog_insights = (state) => {
//   return state.po_backlog_reducer.backlog.fp.insights;
// };

export const get_backlog_insights = (state, category) => {
  return state?.po_backlog_reducer?.backlog?.[category]?.insights || { aging_histogram: null, sample_status: null };
};

export const get_sample_types = (state) => {
  return state?.po_backlog_reducer?.backlog?.sample_types;
};

export const get_backlog_from_redux = (state) => {
  return state?.po_backlog_reducer?.backlog;
};
export const get_backlog_table_data_from_redux_with_type = (state, category) => {
  return state?.po_backlog_reducer?.backlog?.[category]?.table_data;
};